import { render, staticRenderFns } from "./AddScreenProfile.vue?vue&type=template&id=ae40bb92&scoped=true"
import script from "./AddScreenProfile.vue?vue&type=script&lang=js"
export * from "./AddScreenProfile.vue?vue&type=script&lang=js"
import style0 from "./AddScreenProfile.vue?vue&type=style&index=0&id=ae40bb92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae40bb92",
  null
  
)

export default component.exports